import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from "./authReducer";
import { customerReducer } from './customerReducer';
import { slaReducer } from './slaReducer';

export default configureStore({
  reducer: {
    auth: authReducer,
    customer: customerReducer,
    SLA:slaReducer
  },
})